import account from './account';
import auth from './auth';
import casino from './casino';
import chestInventory from './chestInventory';
import config from './config';
import crm from './crm';
import currency from './currency';
import device from './device';
import feature from './feature';
import help from './help';
import localSettings from './localSettings';
import locale from './locale';
import location from './location';
import modal from './modal';
import notification from './notification';
import nps from './nps';
import page from './page';
import resolver from './resolver';
import rewards from './rewards';
import seo from './seo';
import session from './session';
import site from './site';
import * as sports from './sports';
import system from './system';

export type Models = typeof models;

const models = {
  account,
  auth,
  casino,
  chestInventory,
  config,
  crm,
  currency,
  device,
  feature,
  help,
  locale,
  localSettings,
  location,
  modal,
  notification,
  nps,
  page,
  resolver,
  rewards,
  seo,
  session,
  site,
  system,
  ...sports
};

export default models;
